module.exports = __webpack_public_path__ + "img/hexagon-mask.96929110.png";